import script from "./InformacionPersonal.vue?vue&type=script&setup=true&lang=js"
export * from "./InformacionPersonal.vue?vue&type=script&setup=true&lang=js"

import "./InformacionPersonal.vue?vue&type=style&index=0&id=d996256e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d996256e"]])

export default __exports__